import ApiConnector from "@/repository/connector";

class Generations {
  async get({ makeId, modelId, params }) {
    const result = {
      value: null,
      error: null,
    };
    const response = await ApiConnector.connector.get(
      `/v1/makes/${makeId}/models/${modelId}/generations/`,
      { params },
    );
    result.value = response.data;
    result.error = response.detail;
    return result;
  }
}

export default new Generations();
